import { addDays, format, setDay } from 'date-fns';
import React from 'react';
import { View } from 'react-native';
import { FIRST_DAY } from 'design-system/calendar/types';
import { Label } from './Label';
import { RunningSumLineChart } from './Charts';
import { makeLineChartData } from './types';
const HorizontalAxisLabels = React.memo(() => {
    // Evenly distributed. Ignore the right-inset of the chart.
    const labels = [];
    let d = setDay(new Date(), FIRST_DAY);
    for (let i = 0; i < 7; i++) {
        labels.push(format(d, 'iii'));
        d = addDays(d, 1);
    }
    return (<View style={styles.container}>
      {labels.map((label, index) => (<View key={index} style={styles.label}>
          <Label text={label}/>
        </View>))}
    </View>);
});
const WeeklyChart = ({ previous, previousColor, current, currentColor, currency, }) => (<>
    <RunningSumLineChart previous={previous ? makeLineChartData(previous, previousColor) : undefined} current={makeLineChartData(current, currentColor)} currency={currency}/>
    <HorizontalAxisLabels />
  </>);
const styles = {
    container: {
        flexDirection: 'row',
    },
    label: {
        flex: 1,
    },
};
export default WeeklyChart;
